import {Skeleton} from "@mui/material";
import {rolesApi, useGetRoleDetailsQuery} from "@/redux/rtk/admin/settings/roles";
import {useEffect} from "react";
import {useDispatch} from "react-redux";

const RoleName = ({uid}: { uid: number }) => {
    const {data, isLoading} = useGetRoleDetailsQuery(uid);
    const dispatch= useDispatch();
    const name = data?.data?.subRoleDetails?.[0]?.name
    useEffect(() => {
        return () => {
            dispatch(rolesApi.util.resetApiState());
        };
    }, [dispatch]);

    return <>
        {isLoading ? <Skeleton sx={{width: "5rem"}} variant="text"/> :
           name ?? null}
    </>
}

export default RoleName;